import { action, makeObservable, observable } from "mobx";
import { ErrorStore } from "./ErrorStore";

export class AsyncStore {
  @observable loading = false;

  constructor(private errorStore: ErrorStore) {
    makeObservable(this);
  }

  @action
  resetLoading() {
    this.loading = false;
  }

  @action
  showLoading = async (asyncFunction: () => Promise<any>) => {
    this.loading = true;

    return new Promise<void>((resolve, reject) => {
      asyncFunction()
        .then(() => {
          this.resetLoading();
          resolve();
        })
        .catch((error) => {
          this.resetLoading();
          this.errorStore.handleError(error);
          resolve();
        })
    })
  }
}